import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Modal, Image } from 'react-bootstrap';

import CloseIcon from '../../assets/images/prompt_close_icon.svg';
import PromptButton, { BUTTON_TYPES } from "components/base/prompt/BaseButtons";
import BaseTabContainer from "components/base/BaseTabContainer";

import GlobalSettingPeTransactionSection from "./GlobalSettingPeTransactionSection";
import GlobalSettingPerMemberSection from "./GlobalSettingPerMemberSection";

import "./GlobalSettingPrompt.scss"
import { createAction } from "utils";
import { DISPLAY_REWARD_GLOBAL_LIMIT_TARGET_TYPE, EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE } from "config/CustomEnums";

const GlobalSettingPrompt = ({
  hasEditPermission = false,
  globalSetting,
  show,
  onClose = () => { },
}) => {
  const dispatch = useDispatch();
  const [perMemberFormValue, setPerMemberValue] = useState(globalSetting?.perMemberLimit || {});
  const [perTransactionFormValue, setPerTransactionValue] = useState(globalSetting?.perTransactionLimit || {});
  useEffect(()=>{
    dispatch(createAction("earningRuleList/getGlobalLimitSettings")({}))
    dispatch(createAction("earningRuleList/getGlobalSettingLimitTransactionSources")())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(()=>{
    setPerMemberValue(globalSetting?.perMemberLimit || {})
    setPerTransactionValue(globalSetting?.perTransactionLimit || {})
  }, [globalSetting])

  const onConfirm = () => {
    dispatch(createAction("earningRuleList/updateGlobalSetting")({
      pk: globalSetting?.pk,
      perMemberLimit: perMemberFormValue,
      perTransactionLimit: perTransactionFormValue,
      successAction: () => onClose(),
    }))
  }

  const tabs = [
    {
      name: DISPLAY_REWARD_GLOBAL_LIMIT_TARGET_TYPE[EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perMember],
      content: (
        <GlobalSettingPerMemberSection
          formValue={perMemberFormValue}
          setFormValue={setPerMemberValue}
          hasEditPermission={hasEditPermission}
        />
      )
    },
    {
      name: DISPLAY_REWARD_GLOBAL_LIMIT_TARGET_TYPE[EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perTransaction],
      content: (
        <GlobalSettingPeTransactionSection
          formValue={perTransactionFormValue}
          setFormValue={setPerTransactionValue}
          hasEditPermission={hasEditPermission}
        />
      )
    },
  ]

  return <>
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container customer-detail-prompt`}>
        <label className="customer-detail-modal-title">{"Edit Global Setting"}</label>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />
        <BaseTabContainer
          tabs={tabs}
          tabNavClassName="global-setting-nav"
        />
        <div className="global-setting-split-line" />
        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title='Cancel'
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          {hasEditPermission &&
            <PromptButton
              title='Confirm'
              action={onConfirm}
              type={BUTTON_TYPES.main}
            />}
        </div>
      </Modal.Body>
    </Modal>
  </>
}

const mapPropsToState = (state) => ({
  globalSetting: state.earningRuleList.globalSetting,
});

export default connect(mapPropsToState)(GlobalSettingPrompt);